import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, MapIcon, RocketIcon, LineChartIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const STRATEGY_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/6486d1fe-21bb-4643-8aa7-965986bb4576.jpg';
const STEPS = [{
  n: '01',
  icon: SearchIcon,
  title: 'Discover',
  text: 'Understanding your business, market, and opportunities.'
}, {
  n: '02',
  icon: MapIcon,
  title: 'Strategize',
  text: 'Building a roadmap for growth.'
}, {
  n: '03',
  icon: RocketIcon,
  title: 'Execute',
  text: 'Delivering campaigns, partnerships, and communications.'
}, {
  n: '04',
  icon: LineChartIcon,
  title: 'Measure',
  text: 'Optimizing every investment through data and insights.'
}];
export function Approach() {
  return <section id="approach" className="w-full bg-graphite py-24 md:py-32" data-id="element-25" data-mp="3ot5p0tldq62x">
      <div className="max-w-7xl mx-auto px-6" data-id="element-26" data-mp="3orulmuvuj0cc">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-27" data-mp="2qtk8shpg73ei">
          <div data-id="element-28" data-mp="2qs94mgs3btmv">
            <SectionHeading eyebrow="Our Approach" title="A disciplined path from insight to impact." variant="light" data-id="element-29" data-mp="2uvf6zdc310o2" />

            <div className="mt-12 space-y-2" data-id="element-30" data-mp="2gy0fm329qitg">
              {STEPS.map((s, i) => {
              const Icon = s.icon;
              return <motion.div key={s.title} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true,
                margin: '-40px'
              }} transition={{
                duration: 0.5,
                delay: i * 0.1
              }} className="flex gap-5 group" data-id="element-31" data-mp="275up6xro09gd" data-mpi={i}>
                    <div className="flex flex-col items-center" data-id="element-32" data-mp="1o7ibcypt6beg">
                      <div className="flex items-center justify-center w-12 h-12 rounded-full border border-gold/40 text-gold group-hover:bg-gold group-hover:text-navy transition-colors" data-id="element-33" data-mp="1o80dud32dlut">
                        <Icon size={20} data-id="element-34" data-mp="1a39o3vyo8u6v" />
                      </div>
                      {i < STEPS.length - 1 && <span className="w-px flex-1 min-h-[36px] bg-ivory/15 my-1" data-id="element-35" data-mp="158x2pgdmx8sh" />}
                    </div>
                    <div className="pb-8" data-id="element-36" data-mp="vdc29mo7sgku">
                      <div className="flex items-center gap-3" data-id="element-37" data-mp="vedcxq1bj121">
                        <span className="text-xs font-semibold tracking-widest text-gold" data-id="element-38" data-mp="1t0ucz31frsrh">
                          {s.n}
                        </span>
                        <h3 className="font-serif text-2xl text-ivory" data-id="element-39" data-mp="1nzn2uxbtmhhn">
                          {s.title}
                        </h3>
                      </div>
                      <p className="mt-1 text-ivory/70" data-id="element-40" data-mp="1e2if4t2budyq">{s.text}</p>
                    </div>
                  </motion.div>;
            })}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7
        }} className="relative" data-id="element-41" data-mp="2n3glkugze1i">
            <div className="overflow-hidden rounded-2xl" data-id="element-42" data-mp="2o9xx98apb5y5">
              <img src={STRATEGY_IMG} alt="African executive reviewing strategy documents" className="w-full h-[560px] object-cover" data-id="element-43" data-mp="2o8d0rd4ttcxn" />
            </div>
            <div className="absolute -top-6 -left-6 hidden md:block bg-gold text-navy rounded-xl p-6 max-w-[240px] shadow-xl" data-id="element-44" data-mp="2y1k3eq86meu1">
              <p className="font-serif text-xl leading-tight" data-id="element-45" data-mp="370fcca2m2311">
                “If we can't measure it, we question why we're doing it.”
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}